import api from './api';

export async function getAuctions(
  type: 'all' | 'direta' | 'oferta',
  orderBy: 'highest_bids' | undefined,
  idUser: number | undefined,
  idUserBid: number | undefined,
  page: number,
  token: string,
): Promise<any> {
  let baseURL = '/auctions?limit=30';
  if (idUser) {
    baseURL = `${baseURL}&idUser=${idUser}`;
  }
  if (idUserBid) {
    baseURL = `${baseURL}&idUserBid=${idUserBid}`;
  }
  if (type) {
    baseURL = `${baseURL}&type=${type}`;
  }
  if (page) {
    baseURL = `${baseURL}&page=${page}`;
  }
  if (orderBy) {
    baseURL = `${baseURL}&orderBy=${orderBy}`;
  }
  const response = await api.get(baseURL, {
    headers: {
      'x-access-token': token,
    },
  });

  return response.data;
}

export async function createAuctions(
  body: {
    offersEndAt: number;
    qtd: number;
    type: 'direta' | 'oferta';
    idToken: number;
    valueUnity?: number;
    minValue?: number;
    idUser: number;
  },
  token: string,
): Promise<any> {
  const response = await api.post('/auctions', body, {
    headers: {
      'x-access-token': token,
    },
  });

  return response;
}

export async function bidAuctions(
  body: {
    value: number;
    idUserBid: number;
    idAuction: number;
  },
  token: string,
): Promise<any> {
  const response = await api.patch('/auctions/bid', body, {
    headers: {
      'x-access-token': token,
    },
  });

  return response;
}
